import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer, Provider } from '@angular/core';
import { LanguageService } from './language.service';

export const provideLanguage = (): Provider | EnvironmentProviders => {
  // Base providers
  const providers: Array<Provider | EnvironmentProviders> = [
    provideEnvironmentInitializer(() => inject(LanguageService))
  ];
  return makeEnvironmentProviders(providers);
};
